$(function() {
	// @codekit-prepend 'js/functions.js'
	// @codekit-prepend 'js/dropdown.js'

	// @codekit-prepend 'js/home.js'

});